import React from 'react';
import SharedHeaderHomeowner from './SharedHeaderHomeowner';

interface PrivacyPolicyProps {
  onNavigate: (screen: string) => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onNavigate }) => {
  return (
    <div className="container">
      <SharedHeaderHomeowner onNavigate={onNavigate} />
      <div className="content" style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', fontSize: '36px', fontWeight: '700', color: '#1f2937' }}>
          CoreBids Privacy Policy
        </h1>
        
        <div style={{ 
          background: '#ffffff', 
          padding: '40px', 
          borderRadius: '12px', 
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          lineHeight: '1.6',
          color: '#374151'
        }}>
          <p style={{ marginBottom: '20px', fontSize: '16px' }}>
            Welcome to CoreBids! By accessing and using our website and services, you agree to comply with the following privacy practices. Please read carefully, as they govern how your personal information is collected, used, and protected. How your privacy is maintained is also detailed in our Terms & Conditions.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            1. No Sharing for Marketing
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            CoreBids does not share, sell, or disclose your mobile numbers or personal data to third parties for marketing purposes under any circumstances. All information is stored securely, using industry-standard practices to safeguard your data. Your information remains strictly under our control. We retain your data as long as you are subscribed to our email or SMS service. You may request deletion at any time by contacting us at info@corebids.com.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            2. Data Usage
          </h2>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            2a. Types of Data Collected
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            CoreBids may collect the following personal information:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Contact information (name, email address, phone number)</li>
            <li style={{ marginBottom: '8px' }}>Property and project details</li>
            <li style={{ marginBottom: '8px' }}>Transaction details (payment information, billing address)</li>
            <li style={{ marginBottom: '8px' }}>Usage data (website interactions, analytics, preferences)</li>
          </ul>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            2b. Purposes of Data Usage
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We use collected data to:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Process and fulfill orders or services</li>
            <li style={{ marginBottom: '8px' }}>Provide customer support and respond to inquiries</li>
            <li style={{ marginBottom: '8px' }}>Improve our website and services</li>
            <li style={{ marginBottom: '8px' }}>Communicate important updates about projects or services</li>
          </ul>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            2c. Third-Party Involvement
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We may engage third-party service providers, such as payment processors or IT service providers, to support operations. These providers act only on our behalf and are bound by strict confidentiality agreements. They cannot use your data for any other purpose.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            3. No Transfer to External Organizations
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            CoreBids does not transfer personal data to any external organizations, even with your consent. Your data stays exclusively within CoreBids.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            4. Data Protection Measures
          </h2>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            4a. Strict Access Controls
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Only authorized personnel have access to your personal information, and access is granted solely on a need-to-know basis.
          </p>
          
          <h3 style={{ fontSize: '20px', fontWeight: '600', marginTop: '24px', marginBottom: '12px', color: '#374151' }}>
            4b. Robust Security Measures
          </h3>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            We implement industry-standard measures to protect your data, including:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Encryption of sensitive information during transmission and storage</li>
            <li style={{ marginBottom: '8px' }}>Regular security audits to identify and address vulnerabilities</li>
            <li style={{ marginBottom: '8px' }}>Secure storage systems to prevent unauthorized access</li>
          </ul>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            5. Opt-Out Rights
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            You may opt out of our communications at any time:
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            <strong>SMS Messages:</strong> Reply STOP or CANCEL to unsubscribe. Reply HELP for assistance. After unsubscribing, you will receive a final confirmation message, and your number will be removed from our list within 24 hours.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            <strong>Email Messages:</strong> Use the "unsubscribe" link included in all communications.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Opting out does not affect communications required for ongoing projects or contractual obligations. You may also contact us directly at info@corebids.com for assistance.
          </p>
          
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginTop: '32px', marginBottom: '16px', color: '#1f2937' }}>
            6. Messaging Privacy and Terms
          </h2>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            By providing your phone number and agreeing to our Terms & Conditions, you consent to receive SMS messages from CoreBids regarding:
          </p>
          <ul style={{ marginBottom: '20px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>Account notifications</li>
            <li style={{ marginBottom: '8px' }}>Appointment reminders</li>
            <li style={{ marginBottom: '8px' }}>Customer support</li>
            <li style={{ marginBottom: '8px' }}>Promotions and marketing inquiries</li>
            <li style={{ marginBottom: '8px' }}>Orders and ongoing projects</li>
          </ul>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Message frequency varies depending on your engagement. You may receive up to 4 marketing messages per month. Message and data rates may apply. Consent is not a condition of purchase.
          </p>
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            Mobile opt-in information is never shared with third parties. Your personal data is handled according to this Privacy Policy.
          </p>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            If you have questions or concerns about this Privacy Policy, please contact us at info@corebids.com.
          </p>
          
          <p style={{ marginBottom: '16px', fontSize: '16px' }}>
            By using CoreBids services, you agree to the terms outlined in this Privacy Policy.
          </p>
        </div>
        
        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <button 
            className="btn btn-secondary"
            onClick={() => onNavigate('estimate-form')}
            style={{ marginRight: '16px' }}
          >
            Back to Estimate Form
          </button>
          <button 
            onClick={() => onNavigate('landing')}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: 600,
              color: '#ffffff',
              backgroundColor: '#123c3b',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#0d2928';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#123c3b';
            }}
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 